import {jsonArrayMember, jsonObject} from "typedjson";
import {DxPageHeaderGroupOptions} from "./dx-page-header-group-options";

/**
 * Класс опций шапки страницы.
 * @publicApi
 */
@jsonObject
export class DxPageHeaderOptions {
  /**
   * Массив групп элементов шапки.
   * @name _groups
   * @type {DxPageHeaderGroupOptions[]}
   * @defaultValue - пустой массив.
   */
  @jsonArrayMember(DxPageHeaderGroupOptions, {name: 'groups', isRequired: false, emitDefaultValue: false})
  private _groups: DxPageHeaderGroupOptions[] = [];

  /**
   * Возвращает массив групп элементов шапки.
   * @return {DxPageHeaderGroupOptions[]} - массив групп элементов шапки.
   * @public
   */
  get groups(): DxPageHeaderGroupOptions[] {
    return this._groups;
  }

  /**
   * Устанавливает массив групп элементов шапки.
   * @param {DxPageHeaderGroupOptions[]} value - массив групп элементов шапки.
   * @public
   */
  set groups(value: DxPageHeaderGroupOptions[]) {
    this._groups = value;
  }
}
